import { memo } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
// theme
import { bgBlur } from 'theme/css';
// hooks
import { useAuthContext } from 'auth/hooks';
// components
import { NavSectionHorizontal } from 'components/nav-section';
//
import { ADMIN_EMAIL } from 'config-global';

import { HEADER } from '../config-layout';
import { useNavData } from './config-navigation';
import { HeaderShadow } from '../common';

// ----------------------------------------------------------------------

function NavHorizontal() {
    const theme = useTheme();

    const { user } = useAuthContext();

    const navData = useNavData();

    return (
        <AppBar
            component="nav"
            sx={{
                top: HEADER.H_DESKTOP_OFFSET
            }}
        >
            <Toolbar
                sx={{
                    ...bgBlur({
                        color: theme.palette.background.default
                    })
                }}
            >
                <NavSectionHorizontal
                    data={navData}
                    config={{
                        currentRole: user?.primaryEmail === ADMIN_EMAIL ? 'admin' : 'user'
                    }}
                />
            </Toolbar>

            <HeaderShadow />
        </AppBar>
    );
}

export default memo(NavHorizontal);
